// extracted by mini-css-extract-plugin
export default {"wrapper":"container_wrapper__bOY3h","container":"container_container__lhQY3","page":"container_page__DhEe3"};